import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import "./city.css";
import { citiesService, getCityByName } from "../../services/cityService";
import CircleLoading from "../../components/misc/CircleLoading/CircleLoading";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import NotFound from "../NotFound/NotFound";
import BreadcrumbsNavigation from "../../components/Breadcrumbs/BreadcrumbsNavigation";
import STATIC_ROUTES from "../../misc/Static_routes";
import SelectFiltration from "../../components/SelectFiltration/SelectFiltration";
import { filterByValues } from "../../utils/constants";
import { useState } from "react";
import MapCustomIcon from "../../assets/images/map-custom-icon.svg";
import L from "leaflet";
import MapPopup from "../../components/MapPopup/MapPopup";
import { calculateGridElements } from "../../utils/helpers";
import { Link } from "react-router-dom";
import LocationCards from "../../components/LocationCards/LocationCards";

const markerCustomIcon = L.icon({
  iconUrl: MapCustomIcon,
  iconSize: [30, 30],
  iconAnchor: [12.5, 35],
  popupAnchor: [3, -40],
});
const THUNDER_API_KEY = process.env.REACT_APP_THUNDERFOREST_API_KEY;

const City = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [sortOrder, setSortOrder] = useState("mostRecent");
  const [loadIndex, setLoadIndex] = useState(1);
  const pageSize = calculateGridElements();

  const cityName = params?.city;
  const {
    isLoading,
    data: cityResult,
    error,
  } = useQuery({
    queryKey: ["city", cityName],
    queryFn: () => citiesService.getCityByName(cityName),
  });

  const filterBy = (value) => {
    setSortOrder(value);
  };

  return (
    <>
      {isLoading && (
        <p className="loading">
          <CircleLoading />
        </p>
      )}
      {error && !isLoading && <NotFound></NotFound>}
      {cityResult && (
        <div className="city-page">
          <div className="titles_wrapper_main">
            <div className="title_small">{t("welcomeTo")}</div>
            <div className="title_large">
              <span className="title_word_background_line_wrapper">
                {" "}
                <span className="title_word_background_line"></span>
                {cityResult?.data?.name + ","}
              </span>
              {" " + cityResult?.data?.country}
            </div>
          </div>
          <MapContainer
            className="full-height-map"
            center={[cityResult?.data?.langth, cityResult?.data?.latitued]}
            zoom={12}
            scrollWheelZoom={true}
            minZoom={2}
          >
            
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            
            {cityResult?.data?.pins?.map((pin) => {
              return (
                <Marker
                  icon={markerCustomIcon}
                  key={pin?.id}
                  position={[pin?.langth, pin?.latitued]}
                >
                  <Link to={`${location.pathname}/${pin.id}`} state={pin}>
                    <MapPopup
                      cityName={pin?.name}
                      pinCount={pin?.designsCount}
                    ></MapPopup>
                  </Link>
                </Marker>
              );
            })}
          </MapContainer>
          <div className="page_content">
            <div className="curr_city_title_wrapper">
              <p className="curr_city_title">CURRENT PLACES</p>
              <p className="curr_city_subtitle">
                Discover the places where you can make a difference.
              </p>
            </div>
            <div className="breadcrumbs_filter">
              <div className="breadcrumbs_container">
                <BreadcrumbsNavigation
                  locations={[
                    { link: STATIC_ROUTES.home, name: "Cotown Map" },
                    { link: `/${params.city}`, name: params.city },
                  ]}
                ></BreadcrumbsNavigation>
              </div>
              <div className="select_filter_home">
                <SelectFiltration
                  values={filterByValues}
                  filterBy={(e) => filterBy(e)}
                ></SelectFiltration>
              </div>
            </div>
            <div className="locations">
              <LocationCards
                locationData={cityResult?.data}
                sortOrder={sortOrder}
                loadIndex={loadIndex}
                pageSize={pageSize}
              ></LocationCards>
            </div>
            <div className="load_more_wrapper">
              <button
                style={{
                  display:
                    cityResult?.data?.pins?.length >= loadIndex * pageSize
                      ? "inline"
                      : "none",
                }}
                onClick={() => setLoadIndex((number) => number + 1)}
                className="load_more_btn"
              >
                Load more
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default City;
